(() => {
  if (window.SpiritPricing) return;
  const selector = '[data-spirit-price]';
  const money = (value, currency) => new Intl.NumberFormat(document.documentElement.lang || 'he', {
    style: 'currency', currency: currency || 'ILS', maximumFractionDigits: 2, minimumFractionDigits: value % 100 ? 2 : 0,
  }).format(value / 100);
  const active = (node) => Number(node.dataset.offerPrice) > 0
    && Number(node.dataset.offerPrice) < Number(node.dataset.regularPrice)
    && Number(node.dataset.offerExpires) * 1000 > Date.now();
  const unitPrice = (node) => Number(active(node) ? node.dataset.offerPrice : node.dataset.regularPrice);
  const render = (node) => {
    const isEarly = active(node);
    const changed = node.classList.contains('spirit-price--early') !== isEarly;
    node.classList.toggle('spirit-price--early', isEarly);
    node.hidden = node.hasAttribute('data-offer-only') && !isEarly;
    node.querySelector('[data-price-regular]').hidden = !isEarly;
    node.querySelector('[data-price-deadline]').hidden = !isEarly;
    const community = node.querySelector('[data-price-community]');
    if (community) community.hidden = isEarly;
    // Purchase totals include quantity and add-ons and are maintained by the product form.
    const current = node.querySelector('[data-price-current]');
    if (!current.hasAttribute('data-event-total-price')) {
      node.querySelector('[data-price-regular]').textContent = money(Number(node.dataset.regularPrice), node.dataset.currency);
      current.textContent = money(unitPrice(node), node.dataset.currency);
    }
    return changed;
  };
  let timer;
  const refresh = () => {
    clearTimeout(timer);
    let next = Infinity;
    let changed = false;
    document.querySelectorAll(selector).forEach(node => {
      changed = render(node) || changed;
      const expires = Number(node.dataset.offerExpires) * 1000;
      if (expires > Date.now()) next = Math.min(next, expires - Date.now());
    });
    if (changed) document.dispatchEvent(new Event('spirit:prices-updated'));
    if (Number.isFinite(next)) timer = setTimeout(refresh, Math.min(next + 20, 2147483647));
  };
  window.SpiritPricing = {
    unitPrice,
    setVariant(productId, price, compareAt) {
      document.querySelectorAll(selector).forEach(node => {
        if (node.dataset.productId !== String(productId) || node.dataset.priceContext === 'card') return;
        node.dataset.regularPrice = String(Number(node.dataset.offerPrice) > 0 ? Math.max(price, compareAt || 0) : price);
        render(node);
      });
    },
    refresh,
  };
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
  new MutationObserver(records => {
    if (records.some(r => Array.from(r.addedNodes).some(n => n.nodeType === 1 && (n.matches?.(selector) || n.querySelector?.(selector))))) refresh();
  }).observe(document.documentElement, { childList: true, subtree: true });
  refresh();
})();
